import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Nav from '../Nav';
import { Helmet } from 'react-helmet';
import server from '../../api/server';
import { fetchDocCollection, setID } from '../../actions';
import FileUploader from ".//FileUploader";

const ICON_USER = (
    <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
        <path
            fillRule="evenodd"
            d="M10 10a4 4 0 100-8 4 4 0 000 8zm-7 8a7 7 0 1114 0H3z"
            clipRule="evenodd"
        />
    </svg>
);

const ICON_BACK = (
    <svg className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
        <path
            fillRule="evenodd"
            d="M12.7 4.3a1 1 0 010 1.4L8.4 10l4.3 4.3a1 1 0 01-1.4 1.4l-5-5a1 1 0 010-1.4l5-5a1 1 0 011.4 0z"
            clipRule="evenodd"
        />
    </svg>
);

export class DocumentCollection extends Component {

    componentDidMount() {
        // this.fetchDocumentCollections()
        this.props.fetchDocCollection(this.props.match.params.id);
        this.props.setID(this.props.match.params.id);
    }

    constructor(props) {
        super(props);

        this.state = {
            active_applicant: null
        };
    }


    renderApplicants = () => {
        const applicants = [];
        if (this.props.document_collection.data != null) {
            Object.keys(this.props.document_collection.data.applicants).forEach((key) => {
                if (this.props.document_collection.data.applicants[key].requested_documents != undefined) {
                    const a = this.props.document_collection.data.applicants[key];
                    applicants.push(
                        <section
                            key={key}
                            className="rounded-2xl bg-white shadow-sm border border-[#E5E7EB] p-5 sm:p-6"
                        >
                            <header className="flex items-start gap-3 mb-4">
                                <span
                                    className="inline-flex items-center justify-center h-10 w-10 rounded-xl flex-shrink-0"
                                    style={{ backgroundColor: '#EFEAFE', color: '#5B3FE0' }}
                                >
                                    {ICON_USER}
                                </span>
                                <div className="flex-1 min-w-0">
                                    <h3 className="text-base sm:text-lg font-bold text-[#1F2937]">
                                        {a.name}
                                    </h3>
                                    <p className="mt-1 text-sm text-[#6B7280] leading-relaxed">
                                        Tap Start to upload the documents we've requested for
                                        this applicant.
                                    </p>
                                </div>
                            </header>

                            <button
                                type="button"
                                onClick={() => { this.setState({ active_applicant: key }); }}
                                className="w-full sm:w-auto inline-flex items-center justify-center rounded-xl px-6 py-3 text-sm font-semibold text-white shadow-md transition-transform active:scale-95"
                                style={{ backgroundColor: '#7C5CFC' }}
                            >
                                Start Document Collection →
                            </button>
                        </section>
                    );
                }
            });
        }
        return (
            <div className="space-y-4 sm:space-y-5">
                {applicants}
            </div>
        );
    };

    renderContent = () => {
        if (this.state.active_applicant == null) {
            return this.renderApplicants();
        } else {
            if (this.props.document_collection.data.applicants[this.state.active_applicant].requested_documents == undefined) {
                return (null);
            } else {
                var requested_files = [];
                var requested_documents = this.props.document_collection.data.applicants[this.state.active_applicant].requested_documents;

                // Group by category
                var categories = {};


                Object.keys(requested_documents).forEach(key => {
                    var category = "Files";
                    if (requested_documents[key].category != undefined) {
                        category = requested_documents[key].category;
                    }
                    if (categories[category] == undefined) {
                        categories[category] = [];
                    }
                    categories[category].push(requested_documents[key]);
                });

                console.log(categories, 'CATEGORIES');

                Object.keys(categories).forEach((key) => {

                    // Sort by index
                    var sorted = categories[key].sort((a, b) => (a.index > b.index) ? 1 : -1);

                    // Compute completion count for the category header.
                    // Optional types (min_documents === 0) only join the count
                    // once something has been uploaded to them, so an empty
                    // "anything else" section never holds a category back.
                    var doneCount = 0;
                    var totalCount = 0;
                    sorted.forEach((file) => {
                        var min = Number(file.min_documents);
                        var required = min > 0 ? min : min === 0 ? 0 : 1;
                        var fileLen = (file.files || []).length;
                        if (required === 0 && fileLen === 0) return;
                        totalCount += 1;
                        if (fileLen >= Math.max(required, 1)) doneCount += 1;
                    });
                    var allDone = doneCount === totalCount;
                    // A category holding nothing but empty optional types has
                    // nothing to tally, so label it rather than show "0 of 0".
                    var countLabel = totalCount === 0 ? 'Optional' : `${doneCount} of ${totalCount} uploaded`;
                    var showDone = allDone && totalCount > 0;

                    var file_uploads = [];
                    sorted.forEach((file) => {
                        file_uploads.push(
                            <FileUploader
                                key={file.id}
                                data={file}
                                params={this.props.match.params}
                                applicant_id={this.state.active_applicant}
                            />
                        );
                    });

                    requested_files.push(
                        <div key={key} className="space-y-3">
                            <div className="flex items-center justify-between gap-3 px-1">
                                <h2 className="text-base sm:text-lg font-bold text-[#1F2937]">
                                    {key}
                                </h2>
                                <span
                                    className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wide"
                                    style={{
                                        backgroundColor: showDone ? '#DCFCE7' : '#F5F6FA',
                                        color: showDone ? '#15803D' : '#6B7280',
                                    }}
                                >
                                    <span
                                        className="inline-block h-1.5 w-1.5 rounded-full"
                                        style={{ backgroundColor: showDone ? '#16A34A' : '#9CA0AE' }}
                                    />
                                    {countLabel}
                                </span>
                            </div>
                            <div className="space-y-2.5 sm:space-y-3">
                                {file_uploads}
                            </div>
                        </div>
                    );
                });

                console.log(requested_files);

                const a = this.props.document_collection.data.applicants[this.state.active_applicant];

                return (
                    <div className="space-y-6 sm:space-y-8">
                        <button
                            type="button"
                            onClick={() => { this.setState({ active_applicant: null }); }}
                            className="inline-flex items-center gap-1.5 text-sm font-semibold transition-colors"
                            style={{ color: '#5B3FE0' }}
                        >
                            {ICON_BACK} Back to applicants
                        </button>

                        <div
                            className="rounded-2xl border border-[#E5E7EB] px-5 py-4 sm:px-6 sm:py-5"
                            style={{ backgroundColor: '#EFEAFE' }}
                        >
                            <p
                                className="text-[11px] font-semibold tracking-widest uppercase"
                                style={{ color: '#5B3FE0' }}
                            >
                                Uploading for
                            </p>
                            <p className="mt-1 text-base sm:text-lg font-bold text-[#1F2937]">
                                {a && a.name}
                            </p>
                        </div>

                        <div className="space-y-6 sm:space-y-7">
                            {requested_files}
                        </div>
                    </div>
                );


                // var sorted = requested_files.sort((a, b) => (a.props.data.index > b.props.data.index) ? 1 : -1);

                // return sorted;
            }
        }
    };


    render() {
        return (
            <div
                className="min-h-screen w-full"
                style={{ backgroundColor: '#F5F6FA' }}
            >
                <Helmet>
                    {/*
                      Toggle the modern-page body styles via <html
                      className>. See client/src/index.css ".lg-modern-page"
                      rules - they override the legacy /css/loader.css
                      (which forces html/body to 100px), hide the
                      .full-loader overlay, and set the modern background
                      + font. Using <html> attributes (instead of an
                      inline <style> tag) ensures react-helmet@6.1
                      correctly REMOVES them on unmount so they don't
                      leak into /admin pages.
                    */}
                    <html className="lg-modern-page" />
                    <title>File Upload - LoanGateway</title>
                    <meta name="viewport" content="width=device-width, initial-scale=1" />
                </Helmet>
                <Nav showProgress="false"></Nav>

                <main className="px-4 sm:px-6 lg:px-8 py-6 sm:py-10">
                    <div className="max-w-3xl mx-auto">
                        <Link
                            to={`/dashboard/${this.props.match.params.id}`}
                            className="inline-flex items-center gap-1.5 rounded-full bg-white border border-[#E5E7EB] px-3 py-1.5 text-xs sm:text-sm font-semibold transition-all hover:border-[#C4B5FD] hover:shadow-sm mb-5"
                            style={{ color: '#1F2937' }}
                        >
                            <svg className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor" style={{ color: '#5B3FE0' }}>
                                <path
                                    fillRule="evenodd"
                                    d="M12.7 4.3a1 1 0 010 1.4L8.4 10l4.3 4.3a1 1 0 01-1.4 1.4l-5-5a1 1 0 010-1.4l5-5a1 1 0 011.4 0z"
                                    clipRule="evenodd"
                                />
                            </svg>
                            Back to dashboard
                        </Link>

                        <div className="mb-6 sm:mb-8">
                            <p
                                className="text-xs sm:text-sm font-semibold tracking-wide uppercase"
                                style={{ color: '#5B3FE0' }}
                            >
                                Your application
                            </p>
                            <h1 className="mt-2 text-2xl sm:text-3xl font-bold text-[#1F2937]">
                                File Upload
                            </h1>
                            <p className="mt-2 text-sm sm:text-base text-[#6B7280] leading-relaxed">
                                Upload the supporting documents we've requested. Files are
                                encrypted in transit and only visible to your broker.
                            </p>
                        </div>

                        {this.renderContent()}
                    </div>
                </main>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    document_collection: state.document_collection
});

const mapDispatchToProps = {
    fetchDocCollection,
    setID
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentCollection);
